import {
  Popover,
  PopoverProps,
} from "@jugl-web/ui-components/cross-platform/Popover";
import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { TaskDueDateForm, TaskDueDateFormProps } from "../TaskDueDateForm";

export interface TaskDueDateFormPopoverProps
  extends Omit<TaskDueDateFormProps, "onClose">,
    Pick<PopoverProps, "renderTrigger" | "placement"> {
  className?: string;
}

export const TaskDueDateFormPopover: FC<TaskDueDateFormPopoverProps> = ({
  className,
  placement,
  renderTrigger,
  ...props
}) => (
  <Popover
    renderTrigger={renderTrigger}
    placement={placement}
    className={cx(
      "max-h-screen w-[343px] overflow-y-auto px-4 pt-4 pb-8",
      className
    )}
  >
    {({ onClose }) => <TaskDueDateForm onClose={onClose} {...props} />}
  </Popover>
);
